import React from 'react';
import moment from 'moment';

import { Image, CardWrapper, ContentWrapper, StyledHeading, StyledLink, StyledDate, WrappingLink } from './styled-components';

export const TEXT_POSITION = {
  default: 1,
  bottom: 2,
};

const ImageCard = ({ textPosition, image, urlTitle, title, url, date }) => {
  const ConditionWrapper = ({ condition, wrapper, children }) => (condition ? wrapper(children) : children);

  return (
    <CardWrapper>
      <ConditionWrapper condition={urlTitle || url} wrapper={(children) => <WrappingLink href={url}>{children}</WrappingLink>}>
        <Image src={image} />
        <ContentWrapper position={textPosition}>
          <StyledHeading dark={textPosition === TEXT_POSITION.bottom}>{title}</StyledHeading>
          {date && (
            <StyledDate dark={textPosition === TEXT_POSITION.bottom}>{moment(date).format('MMM DD, YYYY')}</StyledDate>
          )}
          {url && urlTitle && (
            <StyledLink href={url}>
              {urlTitle}
            </StyledLink>
          )}
        </ContentWrapper>
      </ConditionWrapper>
    </CardWrapper>
  );
};

ImageCard.defaultProps = {
  textPosition: TEXT_POSITION.default,
  image: 'https://picsum.photos/600/400',
  urlTitle: false,
  title: 'Merino Runners',
  url: 'http://google.com',
};

export default ImageCard;
